import EventEmitter from "events";
import {newReq} from "@/core/request";

export class Team extends EventEmitter {
    constructor(obj) {
        super();
        this.name = null;
        this.userIds = [];
        this.workingHours = (() => {
            return [
                {start: 16, end: 33, target: 7.5},
                {start: 16, end: 33, target: 7.5},
                {start: 16, end: 33, target: 7.5},
                {start: 16, end: 33, target: 7.5},
                {start: 16, end: 33, target: 7.5},
                {start: 0, end: 0, target: 0},
                {start: 0, end: 0, target: 0},
            ]
        })();
        Object.assign(this, obj);
    }

    create(employeeIds) {
        return newReq('POST', `teams/create`, {
            team: JSON.parse(JSON.stringify(this)),
            employeeIds: employeeIds || []
        })
    }

    delete() {
        return newReq('DELETE', `teams/remove`, {teamId: this._id})
    }

    update(...keys) {
        const updateObj = JSON.parse(JSON.stringify(this))
        Object.keys(this).forEach(key => {
            if (!(keys || []).includes(key))
                delete updateObj[key];
        })
        return newReq('POST', `teams/update`, {...updateObj, _id: this._id})
    }
}